module.exports = __webpack_public_path__ + "static/img/18.bc85f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/18.jpg
// module id = yEDF
// module chunks = 1